(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-menu-tags"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const currentUrl = window.location.href;
    const menuLinks = document.querySelectorAll('.blog-menu-tags .menu-link');
    console.log('menuLinks', menuLinks);
    
    menuLinks.forEach(link => {
      const linkUrl = link.getAttribute('data-url');
      // Verifica se a URL atual corresponde ao link
      console.log(currentUrl, linkUrl);
      if (currentUrl === linkUrl) {
        link.classList.add('active');
      }
    });

    // se for mobile, e tiver poucas opções no menu, que não necessite de horizontal scroll, adiciona um justify-center para centralizar na tela
    const menuList = document.querySelector('.blog-menu-tags .menu-list');
    if (menuList) {
      console.log(window.innerWidth, menuList.clientWidth);
      if (window.innerWidth < 768 && menuList.clientWidth < window.innerWidth) {
        menuList.classList.add('justify-center-forced');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-product-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.cart-product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.cart-product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
